import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../../config';
import { LoanSearchResponse } from '../types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  queryParams: string;
};
const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};
const inventoryTimeout: number = config.validationReviewInventoryApi.requestTimeout;
const validationInventorySearchResultDataUrl: string =
  config.validationReviewInventoryApi.urls.searchResult;

export const getValidationInventorySearchResultTableData = async ({
  authenticationContext,
  queryParams
}: RequestProps): Promise<LoanSearchResponse[]> => {
  try {
    const validationInventorySearchResultDataUrlWithParams =
      validationInventorySearchResultDataUrl + queryParams;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      validationInventorySearchResultDataUrlWithParams,
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error(`Error getting inventory search result table data, ${err!!}`);
  }
};
